import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventResponse, EventContactResponse } from '../../../../../../../../@shared/models/response.module';
import { EventsService } from '../../../../../../../../@shared/services/events-service';
import { AddContact } from '../../../manage-event/components/manage-event-contacts/components/add-contact/add-contact';
import { EditContact } from '../../../manage-event/components/manage-event-contacts/components/edit-contact/edit-contact';
import { _AQH_EVE_24 } from '../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-wizard-step-contacts',
  standalone: false,
  templateUrl: './wizard-step-contacts.html',
  styleUrl: './wizard-step-contacts.css'
})
export class WizardStepContacts {
  @Input() event: EventResponse | null = null;
  @Output() eventUpdated = new EventEmitter<EventResponse>();

  contacts: EventContactResponse[] = [];
  private lastLoadedEventId: number | null = null;

  constructor(
    private modalService: NgbModal,
    private eventService: EventsService
  ) {}

  ngOnInit() {
    this.loadContacts();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['event'] && this.event?.event_id && this.event.event_id !== this.lastLoadedEventId) {
      this.loadContacts();
    }
  }

  loadContacts() {
    if (!this.event?.event_id) return;

    this.lastLoadedEventId = this.event.event_id;
    const params: _AQH_EVE_24 = { event_id: this.event.event_id };
    this.eventService.getEventContacts(params).subscribe((contacts) => {
      this.contacts = contacts || [];
    });
  }

  openAddContactModal() {
    if (!this.event) return;

    const modalRef = this.modalService.open(AddContact, { size: 'md', centered: true });
    modalRef.componentInstance.event = this.event;

    modalRef.result.then((result) => {
      if (result) {
        this.loadContacts();
      }
    }).catch(() => {});
  }

  openEditContactModal(contact: EventContactResponse) {
    if (!this.event) return;

    const modalRef = this.modalService.open(EditContact, { size: 'md', centered: true });
    modalRef.componentInstance.event = this.event;
    modalRef.componentInstance.contact = contact;

    modalRef.result.then((result) => {
      if (result) {
        this.loadContacts();
      }
    }).catch(() => {});
  }

  deleteContact(contact: EventContactResponse) {
    const name = `${contact.first_name} ${contact.last_name}`;
    if (!confirm(`Are you sure you want to delete "${name}"?`)) return;

    this.eventService.deleteEventContact({
      contact_id: contact.contact_id
    }).subscribe({
      next: () => {
        this.loadContacts();
      }
    });
  }
}
